export enum NotificationMoment {
  SameDay = 0,
  DayBefore = 1,
}
